const SearchSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M14 14.002L11.6667 11.6686M11.3333 6.66862C11.3333 7.28146 11.2126 7.88829 10.9781 8.45448C10.7436 9.02066 10.3998 9.53511 9.9665 9.96845C9.53316 10.4018 9.01871 10.7455 8.45252 10.9801C7.88634 11.2146 7.2795 11.3353 6.66667 11.3353C6.05383 11.3353 5.447 11.2146 4.88081 10.9801C4.31462 10.7455 3.80018 10.4018 3.36683 9.96845C2.93349 9.53511 2.58975 9.02066 2.35523 8.45448C2.12071 7.88829 2 7.28146 2 6.66862C2 5.43094 2.49167 4.24396 3.36683 3.36879C4.242 2.49362 5.42899 2.00195 6.66667 2.00195C7.90434 2.00195 9.09133 2.49362 9.9665 3.36879C10.8417 4.24396 11.3333 5.43094 11.3333 6.66862Z"
        stroke="#333333"
        strokeWidth="1.2878"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default SearchSvg;
